import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import helper from '../../../helper';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import guestRequestApi from '../../../api/guestRequestApi';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import enumMapper from '../../../enumMapper';
import stationApi from '../../../api/stationApi';

const EditGuestRequestForm = ({ row, refreshGrid }) => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [originCities, setOriginCities] = useState([])
  const [destCities, setDestCities] = useState([])

  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues } = useForm({
    defaultValues: {
      from: row.persian_From,
      to: row.persian_To,
      originStation: { id: row.originStation, label: row.originStationTitle }, // important: start as null, not undefined
      destinationStation: { id: row.destinationStation, label: row.destinationStationTitle },
    },
    resolver: yupResolver(schema),
  });

  function GetGregorianDate(input) {
    let dateGregorian = null;
    if (input) {
      let date = new DateObject({
        date: input,
        calendar: persian,
        locale: persian_fa
      });

      var dateStr = date.year + '/' + date.month.number + '/' + date.day;
      dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    return dateGregorian
  }

  const onSubmit = (data) => {
    setSubmitLoading(true);
    const newData = {
      "from": GetGregorianDate(data.from),
      "to": GetGregorianDate(data.to),
      "originStation": data.originStation?.id,
      "destinationStation": data.destinationStation?.id
    }
    guestRequestApi.Update(row?.id, newData).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        resetForm();
        refreshGrid(true)
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
      else if (err.response && err.response.data) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
      }
      else if (err.message) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
      }
      else {
        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };

  useEffect(() => {
    stationApi.StationConsistencyByCountryDropDown()
      .then((res) => {
        const originCities = row.service.guestServiceType
          ? getOriginAndDestination(parseInt(row.service.guestServiceType), res.data?.items)?.origin
          : [];
        setOriginCities(originCities);

        const destCities = row.service.guestServiceType
          ? getOriginAndDestination(parseInt(row.service.guestServiceType), res.data?.items)?.destination
          : [];
        setDestCities(destCities)

      })
      .catch((error) => console.log(error));
  }, []);

  function getOriginAndDestination(input, items) {
    const toArray = (list) =>
      Object.entries(list).map(([id, label]) => ({
        id: Number(id),
        label
      }));

    const country0 =
      items.find(item => item.country === 0)?.list || {};

    const country1 =
      items.find(item => item.country === 1)?.list || {};

    if (input === 40) {
      return {
        origin: toArray(country0),
        destination: toArray(country1)
      };
    }

    if (input === 41) {
      return {
        origin: toArray(country1),
        destination: toArray(country0)
      };
    }

    return null;
  }

  const resetForm = () => {
    resetField("");
  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* تاریخ‌ها */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Controller
              control={control}
              name="from"
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  value={value || null}
                  onChange={(date) => {
                    onChange(date?.isValid ? date : null);
                  }}
                  format="YYYY/MM/DD"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  render={
                    <CustomDateInput
                      label="از"
                      error={!!errors?.from}
                      helperText={errors?.from?.message}
                    />
                  }
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Controller
              control={control}
              name="to"
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  value={value || null}
                  onChange={(date) => {
                    onChange(date?.isValid ? date : null);
                  }}
                  format="YYYY/MM/DD"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  render={
                    <CustomDateInput
                      label="تا"
                      error={!!errors?.to}
                      helperText={errors?.to?.message}
                    />
                  }
                />
              )}
            />
          </Grid>
        

        {/* مبدا و مقصد */}
        {row.service.guestServices === enumMapper.GuestServices.Flight && (
      <>
            <Grid item xs={12} sm={6}>
              <Controller
                name="originStation"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    value={field.value || null}
                    options={originCities}
                    getOptionLabel={(o) => o?.label || ""}
                    onChange={(_, value) => field.onChange(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ایستگاه مبدأ"
                        error={!!errors?.originStation}
                        helperText={errors?.originStation?.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Controller
                name="destinationStation"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    value={field.value || null}
                    options={destCities}
                    getOptionLabel={(o) => o?.label || ""}
                    onChange={(_, value) => field.onChange(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ایستگاه مقصد"
                        error={!!errors?.destinationStation}
                        helperText={errors?.destinationStation?.message}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          </>
        )}
</Grid>
        <Box mt={3} display="flex" justifyContent="flex-start">
          <Button
            type="submit"
            variant="contained"
            disabled={submitLoading}
          >
            {submitLoading ? (
              <BeatLoading loading size={8} color="#fff" />
            ) : (
              "ثبت"
            )}
          </Button>
        </Box>
      </form>
    </div>
  )
}

export default EditGuestRequestForm